"use strict";
const { getProduct } = require("../graphql/mob_queries");
const { getGroupCourseByMssId, listMOBConfigsByAppInstanceMobVersion } = require("../graphql/queries")
const { listArticlesByProductAndPointSell } = require("../graphql/mob_queries");
const { listOrderrsByAppInstance } = require("../graphql/queries");
const { rentSizeAvailability } = require("../graphql/queries");
const { rentArticleAvailability } = require("../graphql/queries");
const { getStaticContent } = require("../graphql/queries");
const {
  listRentProductRequirementByAppInstance,
} = require("../graphql/queries");
const { listRentCategoriesByProductType } = require("../graphql/mob_queries");
const { listLocationsByAppInstance } = require("../graphql/mob_queries");
const { listPointSellsByAppInstance } = require("../graphql/mob_queries");
const { listPointMeetingsByAppInstance } = require("../graphql/mob_queries");
const { createOrderrDraft } = require("../graphql/mob_queries");
const { getSet } = require("../graphql/mob_queries");
const { getOrderr } = require("../graphql/mob_queries");
const { removeFromCart } = require("../graphql/mob_queries");
const { addToCart } = require("../graphql/mob_queries");
const { updateOrderrPickupAndPaymentInfo } = require("../graphql/mob_queries");
const { checkoutOrderr } = require("../graphql/mob_queries");
const { getPayment } = require("../graphql/mob_queries");
const { listStaticContentByAppInstance } = require("../graphql/mob_queries");
const { schoolListVariants } = require("../graphql/queries");
const { schoolListFreeSlots } = require("../graphql/queries");
const { schoolListGroupCourse } = require("../graphql/queries");
const { schoolListGroupCourseLesson } = require("../graphql/queries");
const { applyDiscountCode } = require("../graphql/mob_queries");
const { sendCourseInquiry } = require("../graphql/mutations");
const { API, graphqlOperation } = require("aws-amplify");
const moment = require("moment");

class APIAdapter {
  static get AUTH_MODE_API_KEY() {
    return "API_KEY";
  }

  static async graphQLCall(graphqlOperation, authMode) {
    let graphQLOptions = graphqlOperation;

    let graphQLOptionsApiKey = {
      ...graphQLOptions,
      authMode: authMode,
    };

    return API.graphql(graphQLOptionsApiKey);
  }

  /**
   * Nacte hlavni konfiguraci Mates On-line Bookingu
   * API_KEY
   *
   * @param {String} appInstance
   * @returns
   */
  static async getLatestMOBConfig(appInstance) {
    const resultSet = await APIAdapter.graphQLCall(
      graphqlOperation(listMOBConfigsByAppInstanceMobVersion, {
        appInstance: appInstance,
        sortDirection: "DESC",
        limit: 1
      }),
      APIAdapter.AUTH_MODE_API_KEY
    );

    let mobConfigLatest = null;
    for (
      let i = 0;
      i < resultSet.data.listMOBConfigsByAppInstanceMobVersion.items.length;
      i++
    ) {
      let mobc = resultSet.data.listMOBConfigsByAppInstanceMobVersion.items[i];
      if (mobConfigLatest == null) {
        mobConfigLatest = mobc;
      }

      if (mobConfigLatest.mobVersion < mobc.mobVersion) {
        mobConfigLatest = mobc;
      }
    }

    return mobConfigLatest;
  }

  /**
   * API_KEY
   *
   * @param {*} appInstance
   * @param {*} mobVersion
   * @returns
   */
  static async listLocations(appInstance, mobVersion) {
    try {
      const resultSet = await APIAdapter.graphQLCall(
        graphqlOperation(listLocationsByAppInstance, {
          appInstance: appInstance,
          mobVersion: {
            eq: mobVersion,
          },
        }),
        APIAdapter.AUTH_MODE_API_KEY
      );

      return resultSet.data.listLocationsByAppInstance.items;
    } catch (error) {
      console.error(error);
      return [];
    }
  }

  /**
   * API_KEY
   *
   * @param {*} appInstance
   * @param {*} mobVersion
   * @returns
   */
  static async listPointSell(appInstance, mobVersion) {
    try {
      const resultSet = await APIAdapter.graphQLCall(
        graphqlOperation(listPointSellsByAppInstance, {
          appInstance: appInstance,
          mobVersion: {
            eq: mobVersion,
          },
        }),
        APIAdapter.AUTH_MODE_API_KEY
      );

      return resultSet.data.listPointSellsByAppInstance.items;
    } catch (error) {
      console.error(error);
      return [];
    }
  }

  static async listPointMeeting(appInstance, mobVersion) {
    try {
      const resultSet = await APIAdapter.graphQLCall(
        graphqlOperation(listPointMeetingsByAppInstance, {
          appInstance: appInstance,
          mobVersion: {
            eq: mobVersion,
          },
        }),
        APIAdapter.AUTH_MODE_API_KEY
      );

      return resultSet.data.listPointMeetingsByAppInstance.items;
    } catch (error) {
      console.error(error);
      return [];
    }
  }

  /**
   * API_KEY
   *
   * @param {*} appInstance
   * @param {*} mobVersion
   * @returns
   */
  static async listStaticContent(appInstance, mobVersion) {
    try {
      const resultSet = await APIAdapter.graphQLCall(
        graphqlOperation(listStaticContentByAppInstance, {
          appInstance: appInstance,
          mobVersion: {
            eq: mobVersion,
          },
        }),
        APIAdapter.AUTH_MODE_API_KEY
      );

      return resultSet.data.listStaticContentByAppInstance.items;
    } catch (error) {
      console.error(error);
      return [];
    }
  }

  static async getStaticContent(staticContentId) {
    try {
      const resultSet = await APIAdapter.graphQLCall(
        graphqlOperation(getStaticContent, {
          id: staticContentId,
        }),
        APIAdapter.AUTH_MODE_API_KEY
      );

      return resultSet.data.getStaticContent;
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  /**
   *
   * @param {*} appInstance
   * @param {*} mobVersion
   * @param {*} productType
   * @returns
   */
  static async loadListCategoriesAndProductsByProductType(
    appInstance,
    mobVersion,
    productType
  ) {
    try {
      let resultSet = await APIAdapter.graphQLCall(
        graphqlOperation(listRentCategoriesByProductType, {
          appInstance: appInstance,
          mobVersion: mobVersion,
          productType: productType,
        }),
        APIAdapter.AUTH_MODE_API_KEY
      );

      return resultSet.data.listCategoriesByProductType.items.sort(
        function compare(a, b) {
          return a.orderNumber - b.orderNumber;
        }
      );
    } catch (error) {
      console.error(error);
      return [];
    }
  }

  static async getProduct(productId) {
    const result = await APIAdapter.graphQLCall(
      graphqlOperation(getProduct, {
        id: productId,
      }),
      APIAdapter.AUTH_MODE_API_KEY
    );

    let product = result.data.getProduct;
    return product;
  }

  static async getSet(setId) {
    const result = await APIAdapter.graphQLCall(
      graphqlOperation(getSet, {
        id: setId,
      }),
      APIAdapter.AUTH_MODE_API_KEY
    );

    let set = result.data.getSet;
    return set;
  }

  static async listArticlesByProductAndPointSell(productId, pointSellId) {
    const resultArticles = await APIAdapter.graphQLCall(
      graphqlOperation(listArticlesByProductAndPointSell, {
        productId: productId,
        pointSellId: {
          eq: pointSellId,
        },
      }),
      APIAdapter.AUTH_MODE_API_KEY
    );
    let articles = resultArticles.data.listArticlesByProductAndPointSell.items;
    return articles;
  }

  /**
   * Vytvori novou rozpracovanou objednavku ve stavu DRAFT
   *
   * @param {OrderrDraftIn} createOrderrDraftIn
   * @returns ID of created orderr
   */
  static async createOrderrDraft(createOrderrDraftIn) {
    try {
      const result = await APIAdapter.graphQLCall(
        graphqlOperation(createOrderrDraft, {
          input: createOrderrDraftIn,
        }),
        APIAdapter.AUTH_MODE_API_KEY
      );

      console.log("objednavka zalozena");
      console.log(result.data.createOrderrDraft);

      return result.data.createOrderrDraft.id;
    } catch (error) {
      console.error("Nepodarilo se zalozit objednavku", error);
      return null;
    }
  }

  static async getOrderr(orderrId) {
    try {
      const result = await APIAdapter.graphQLCall(
        graphqlOperation(getOrderr, {
          id: orderrId,
        }),
        APIAdapter.AUTH_MODE_API_KEY
      );
      return result.data.getOrderr;
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  static async getPayment(paymentId) {
    console.log("getPayment");
    try {
      const result = await APIAdapter.graphQLCall(
        graphqlOperation(getPayment, {
          id: paymentId,
        }),
        APIAdapter.AUTH_MODE_API_KEY
      );
      console.log("getPayment -- result");
      console.log(result.data.getPayment);
      return result.data.getPayment;
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  // TODO: predelat na nacteni objednavek prihlaseneho uzivatele - podle klienta nebo podle vlastnika
  static async listOrderrs(appInstance) {
    try {
      let resultSet = await APIAdapter.graphQLCall(
        graphqlOperation(listOrderrsByAppInstance, {
          appInstance: appInstance,
        }),
        APIAdapter.AUTH_MODE_API_KEY
      );
      return resultSet.data.listOrderrsByAppInstance.items;
    } catch (error) {
      console.error(error);
      return [];
    }
  }

  static async removeOrderrItemGroupFromCart(orderrItemGroupId) {
    try {
      const result = await APIAdapter.graphQLCall(
        graphqlOperation(removeFromCart, {
          orderrItemGroupId: orderrItemGroupId,
        }),
        APIAdapter.AUTH_MODE_API_KEY
      );
      console.log(result);
    } catch (error) {
      console.error(error);
    }
  }

  static async addOrderrItemGroupToCart(addToCartIn) {
    console.log("addToCartIn - before transform:");
    console.log(addToCartIn);

    let ois = addToCartIn.orderrItems;
    let oisTransf = [];
    for (let i = 0; i < ois.length; i++) {
      let oi = {
        ...ois[i],
      };
      if (ois[i].article != null) {
        oi.article = {
          mssId: ois[i].article.mssId,
          articleType: ois[i].article.articleType,
          productId: ois[i].article.productId,
          pointSellId: ois[i].article.pointSellId,
          title: ois[i].article.title,
          description: ois[i].article.description,
          articleCountTotal: ois[i].article.articleCountTotal,
          articleNumber: ois[i].article.articleNumber,
          articleNumber2: ois[i].article.articleNumber2,
          size: ois[i].article.size,
          sizeUnit: ois[i].article.sizeUnit,
          rentLevel: ois[i].article.rentLevel,
          rentAgeGroup: ois[i].article.rentAgeGroup,
          rentGender: ois[i].article.rentGender,
          aggItem: ois[i].article.aggItem,
        };
      }
      oisTransf.push(oi);
    }

    addToCartIn.orderrItems = oisTransf;

    console.log("addToCartIn - after transform:");
    console.log(addToCartIn);

    const result = await APIAdapter.graphQLCall(
      graphqlOperation(addToCart, {
        input: addToCartIn,
      }),
      APIAdapter.AUTH_MODE_API_KEY
    );
    console.log(result);
  }

  static async updateOrderrPickupAndPaymentInfo(
    orderrId,
    datePickUp,
    paymentMethod,
    dateTryOut,
    description
  ) {
    try {
      const result = await APIAdapter.graphQLCall(
        graphqlOperation(updateOrderrPickupAndPaymentInfo, {
          orderrId: orderrId,
          datePickUp: datePickUp,
          paymentMethod: paymentMethod,
          dateTryOut: dateTryOut,
          description: description
        }),
        APIAdapter.AUTH_MODE_API_KEY
      );
      console.log("updateOrderrPickupAndPaymentInfo -- done:");
      console.log(result.data.updateOrderrPickupAndPaymentInfo);
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  static async checkoutOrderr(orderrId, createSubjectIn) {
    try {
      let updateResult = await APIAdapter.graphQLCall(
        graphqlOperation(checkoutOrderr, {
          orderrId: orderrId,
          subjectIn: createSubjectIn,
        }),
        APIAdapter.AUTH_MODE_API_KEY
      );
      console.log(updateResult);
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  static async schoolListVariants(
    appInstance,
    mobVersion,
    dateFrom,
    dateTo,
    locationMssId,
    pointMeetingMssId,
    skillMssId,
    languageCodes,
    requestedLengthTotal,
    requestedLengthAvg,
    candidateSlots
  ) {
    console.log("schoolListVariants");

    const resultset = await APIAdapter.graphQLCall(
      graphqlOperation(schoolListVariants, {
        appInstance: appInstance,
        mobVersion: mobVersion,
        locationMssId: locationMssId,
        pointMeetingMssId: pointMeetingMssId,
        skillMssId: skillMssId,
        languageCodes: languageCodes,
        dateFrom: moment(dateFrom).format("YYYY-MM-DD"),
        dateTo: moment(dateTo).format("YYYY-MM-DD"),
        requestedLengthTotal: requestedLengthTotal,
        requestedLengthAvg: requestedLengthAvg,
        candidateSlots: candidateSlots,
      }),
      APIAdapter.AUTH_MODE_API_KEY
    );
    return resultset.data.schoolListVariants;
  }

  static async schoolListFreeSlots(
    appInstance,
    mobVersion,
    dateFrom,
    dateTo,
    variantIds,
    candidateSlots,
    pointMeetingMssId
  ) {
    console.log("schoolListFreeSlots");

    console.log("ID pointu: ");
    console.log(pointMeetingMssId);

    const resultset = await APIAdapter.graphQLCall(
      graphqlOperation(schoolListFreeSlots, {
        appInstance: appInstance,
        mobVersion: mobVersion,
        dateFrom: moment(dateFrom).format("YYYY-MM-DD"),
        dateTo: moment(dateTo).format("YYYY-MM-DD"),
        variantIds: variantIds,
        candidateSlots: candidateSlots,
        pointMeetingMssId: pointMeetingMssId,
      }),
      APIAdapter.AUTH_MODE_API_KEY
    );
    return resultset.data.schoolListFreeSlots;
  }

  static async loadRentSizeAvailability(
    appInstance,
    mobVersion,
    pointSellId,
    productId,
    dateFrom,
    dateTo
  ) {
    console.log("loadRentSizeAvailability");
    console.log(moment(dateFrom).format("YYYY-MM-DDT08:00:00.000Z"));
    console.log(moment(dateTo).format("YYYY-MM-DDT18:00:00.000Z"));

    const resultset = await APIAdapter.graphQLCall(
      graphqlOperation(rentSizeAvailability, {
        appInstance: appInstance,
        mobVersion: mobVersion,
        pointSellId: pointSellId,
        productId: productId,
        dateFrom: moment(dateFrom).format("YYYY-MM-DDT08:00:00.000Z"),
        dateTo: moment(dateTo).format("YYYY-MM-DDT20:00:00.000Z"),
      }),
      APIAdapter.AUTH_MODE_API_KEY
    );

    return resultset.data.rentSizeAvailability;
  }

  static async loadRentArticlesBySize(
    appInstance,
    mobVersion,
    pointSellId,
    productId,
    dateStart,
    dateEnd,
    selectedSize
  ) {
    try {
      const resultset = await APIAdapter.graphQLCall(
        graphqlOperation(rentArticleAvailability, {
          appInstance: appInstance,
          mobVersion: mobVersion,
          pointSellId: pointSellId,
          productId: productId,
          dateFrom: moment(dateStart).format("YYYY-MM-DDTHH:mm:00.000Z"),
          dateTo: moment(dateEnd).format("YYYY-MM-DDTHH:mm:00.000Z"),
          size: selectedSize != null ? selectedSize.size : null,
        }),
        APIAdapter.AUTH_MODE_API_KEY
      );
      console.log(resultset);
      return resultset.data.rentArticleAvailability;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  static async listRentProductRequirements(appInstance, mobVersion) {
    try {
      const resultSet = await APIAdapter.graphQLCall(
        graphqlOperation(listRentProductRequirementByAppInstance, {
          appInstance: appInstance,
          mobVersion: {
            eq: mobVersion,
          },
        }),
        APIAdapter.AUTH_MODE_API_KEY
      );

      return resultSet.data.listRentProductRequirementByAppInstance.items;
    } catch (error) {
      console.error(error);
      return [];
    }
  }

  static async schoolListGroupCourse(
    appInstance,
    mobVersion,
    productMssId,
    locationMssId,
    skillLevelClient,
    languageCodes,
    dateFrom,
    dateTo
  ) {
    try {
      const resultset = await APIAdapter.graphQLCall(
        graphqlOperation(schoolListGroupCourse, {
          appInstance,
          mobVersion,
          productMssId,
          locationMssId,
          skillLevelClient,
          languageCodes,
          dateFrom: moment(dateFrom).format("YYYY-MM-DD"),
          dateTo: moment(dateTo).format("YYYY-MM-DD"),
        }),
        APIAdapter.AUTH_MODE_API_KEY
      );
      console.log(resultset);
      return resultset.data.schoolListGroupCourse;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  static async getGroupCourseByMssId(
    appInstance,
    mobVersion,
    productMssId,
    groupCourseMssId
  ) {
    try {
      const resultset = await APIAdapter.graphQLCall(
        graphqlOperation(getGroupCourseByMssId, {
          appInstance,
          mobVersion,
          productMssId,
          groupCourseMssId
        }),
        APIAdapter.AUTH_MODE_API_KEY
      );
      console.log(resultset);
      return resultset.data.getGroupCourseByMssId;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  static async schoolListGroupCourseLesson(
      appInstance,
      mobVersion,
      groupCourseMssId,
      dateFrom,
      dateTo
  ) {
    try {
      const resultset = await APIAdapter.graphQLCall(
        graphqlOperation(schoolListGroupCourseLesson, {
          appInstance,
          mobVersion,
          groupCourseMssId,
          dateFrom: moment(dateFrom).format("YYYY-MM-DD"),
          dateTo: moment(dateTo).format("YYYY-MM-DD")
        }),
        APIAdapter.AUTH_MODE_API_KEY
      );
      console.log(resultset);
      return resultset.data.schoolListGroupCourseLesson;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  static async applyDiscountCode(orderId, code) {
    console.log("API Adapter:: applyDiscountCode");
    console.log(orderId);
    console.log(code);
    try {
      const resultset = await APIAdapter.graphQLCall(
        graphqlOperation(applyDiscountCode, {
          orderrId: orderId,
          code: code,
        }),
        APIAdapter.AUTH_MODE_API_KEY
      );
      return resultset;
    } catch (e) {
      console.error(e);
      throw e;
    }
  }

  static async sendCourseInquiry(mobConfig, locale, courseInquiryPayload) {
    console.log("API Adapter:: sendCourseInquiry");
    console.log(mobConfig);
    console.log(courseInquiryPayload);

    // appInstance: $appInstance
    // mobVersion: $mobVersion
    // locale: $locale

    try {
      const resultset = await APIAdapter.graphQLCall(
        graphqlOperation(sendCourseInquiry, {
          appInstance: mobConfig.appInstance,
          mobVersion: mobConfig.mobVersion,
          locale: locale,
          courseInquiryPayload: courseInquiryPayload,
        }),
        APIAdapter.AUTH_MODE_API_KEY
      );
      return resultset;
    } catch (e) {
      console.error(e);
      throw e;
    }
  }
}

module.exports = APIAdapter;
